"use client";

import { Toaster as Sonner, type ToasterProps } from "sonner";
import { CheckCircle2, Info, AlertTriangle, XCircle, Loader2 } from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      offset={16}
      mobileOffset={{ bottom: 84, left: 12, right: 12 }}
      className="toaster group"
      icons={{
        success: <CheckCircle2 className="size-4 text-success" />,
        info: <Info className="size-4 text-accent" />,
        warning: <AlertTriangle className="size-4 text-ember" />,
        error: <XCircle className="size-4 text-danger" />,
        loading: <Loader2 className="size-4 animate-spin text-ink-3" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "surface-float flex w-full items-center gap-3 rounded-lg px-4 py-3 text-[13.5px] text-ink font-sans",
          title: "font-medium text-ink",
          description: "text-ink-3 text-[12.5px]",
          actionButton:
            "ml-auto h-7 rounded-md bg-accent-strong px-2.5 text-xs font-medium text-white hover:bg-accent-hover",
          cancelButton:
            "ml-auto h-7 rounded-md border border-line-strong px-2.5 text-xs font-medium text-ink-2",
          closeButton: "text-ink-3",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
